// extracted by mini-css-extract-plugin
export default {"phoneInput":"PhoneInputComponent_phoneInput__j7kOr"};